import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Column, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { AttachmentFile } from './AttachmentFile';
import { AttachmentsTestIds } from './Attachments.utils';
export const Attachments = (param)=>{
    let { files, onRemove, disableDownloadLinks } = param;
    const { t } = useLocaleKeys('common.attachments');
    if (files.length === 0) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": AttachmentsTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "normal",
                testId: AttachmentsTestIds.Title(),
                children: t.title()
            }),
            /*#__PURE__*/ _jsx(Column, {
                children: files.map((file, index)=>/*#__PURE__*/ _jsx(AttachmentFile, {
                        disableDownloadLink: disableDownloadLinks,
                        file: file,
                        index: index,
                        onRemove: onRemove
                    }, file.id))
            })
        ]
    });
};
